import * as z from "zod/v4";
export const ContentTypeSchema = z.enum([
    "UNSPECIFIED",
    "PRODUCT",
    "PRODUCT_GROUP",
    "ORDER_ID",
    "ORDER_NAME",
    "ORDER_NUMBER",
]);
export const ProductIdentifierSchema = z.enum([
    "UNSPECIFIED",
    "PRODUCT_ID",
    "PRODUCT_SKU",
    "VARIANT_ID",
]);
const CtidSchema_ = z.object({
    id: z.string(),
    userCreated: z.boolean(),
    selected: z.boolean(),
});
export const CtidSchema = CtidSchema_;
const GoogleAdsCtidsSchema_ = z.object({
    ctids: z.record(z.string(), CtidSchema),
});
export const GoogleAdsCtidsSchema = GoogleAdsCtidsSchema_;
const IntegrationMetadataSchema_ = z.object({
    contentType: ContentTypeSchema,
    productIdentifier: ProductIdentifierSchema,
    googleAdsCtids: GoogleAdsCtidsSchema.optional(),
});
export const IntegrationMetadataSchema = IntegrationMetadataSchema_;
//# sourceMappingURL=metadata.js.map